export default __webpack_public_path__ + "static/compass_icon-c1d28db0c767b965e639a8fae416df00.svg";